import React from 'react';
// Models
import { IPage } from '@root/models/Page';
// Mui
import {
  Divider, FormControlLabel, Switch
} from '@mui/material';
// Components
import Episodes from 'app/components/PageEpisodes';
import ColorPalette from 'app/components/ColorPalette';
import TagPicker from 'app/components/TagPicker';
import Icon from 'app/components/Icon';
// i18next
import { useTranslation } from 'react-i18next';
import { Loader } from 'app/components/Utilities';

type Props = {
  page: IPage;
}

const CardPageStaplePlaceholder:React.FC<Props> = ({
  // Props
  page
}) => {
  const { t } = useTranslation();

  if ( !page ) return <Loader />;
  return (
    <React.Fragment>
      <Icon
        icon="stapled"
        size="small"
        label={t('dialogs.cardPage.stapled')}
      />
      <Divider style={{ marginTop: '16px', marginBottom: '16px' }} />
      {page.tag ? (
        <div style={{ marginBottom: '16px' }}>
          <TagPicker
            id="page-tag-form"
            activeTags={page.tag ? [page.tag] : []}
          />
        </div>
      ) : null}
      {/* Color */}
      {page.colors && page.colors.length ? (
        <ColorPalette sx={{ mb: 4 }} activeColors={page.colors} showNoColorValue={false}>
          {(color) => (
            <ColorPalette.Item key={color} color={color} />
          )}
        </ColorPalette>
      ) : null}
      <div style={{ marginBottom: '16px' }}>
        <FormControlLabel
          control={
            <Switch
              color="default"
              name="inWorkspace"
              checked={page.inWorkspace}
              disabled={true}
              onChange={() => null}
            />
          }
          label={t('dialogs.cardPage.includePageIntoWorkspace')}
        />
      </div>
      <Episodes>
        <Episodes.List />
      </Episodes>
    </React.Fragment>
  )
}

export default CardPageStaplePlaceholder;
